import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-custom-loader',
  templateUrl: './custom-loader.component.html',
  styleUrls: ['./custom-loader.component.scss'],
  standalone: false
})
export class CustomLoaderComponent {
  @Input() isVisible = false;
  @Input() message = 'Laster...';
}
